export function resolveTalentDetailBackTarget(from) {
  return typeof from === 'string' && from.length > 0 ? from : '/talents';
}

export function resolveVisibleTalentDetailHash(hash, visibleSectionIds = []) {
  if (typeof hash !== 'string' || hash.length <= 1) return null;

  let sectionId;
  try {
    sectionId = decodeURIComponent(hash.slice(1));
  } catch {
    return null;
  }

  return visibleSectionIds.includes(sectionId) ? sectionId : null;
}

export function resolveTalentDetailEntryTarget(hash, visibleSectionIds = []) {
  const sectionId = resolveVisibleTalentDetailHash(hash, visibleSectionIds);
  return sectionId ? { type: 'section', sectionId } : { type: 'top' };
}

export function isTalentDetailLoadedForRoute(talent, routeId) {
  return talent?.id != null && String(talent.id) === String(routeId);
}

export function getTalentDetailScrollBehavior(matchMedia) {
  try {
    return matchMedia?.('(prefers-reduced-motion: reduce)')?.matches ? 'auto' : 'smooth';
  } catch {
    return 'smooth';
  }
}

export function scrollToTalentDetailSection({
  sectionId,
  visibleSectionIds = [],
  documentRef = globalThis.document,
  matchMedia = globalThis.matchMedia?.bind(globalThis),
} = {}) {
  if (!visibleSectionIds.includes(sectionId)) return false;

  const element = documentRef?.getElementById?.(sectionId);
  if (!element) return false;

  element.scrollIntoView({
    behavior: getTalentDetailScrollBehavior(matchMedia),
    block: 'start',
  });
  return true;
}
